import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

const SECTIONS = [
  {
    h: "1. General Informational Purpose",
    p: "All content, assessments, scores, ratings, benchmarks, and AI-generated reports provided by SCMBrain are for general informational and educational purposes only. They do not constitute consulting, legal, financial, accounting, or professional advice of any kind, and should not be relied upon as a substitute for independent professional judgment.",
  },
  {
    h: "2. \"As Is\" and \"As Available\"",
    p: "The Services and all outputs are provided on an \"as is\" and \"as available\" basis, without warranties of any kind, express or implied. SCMBrain makes no representation that any output is accurate, complete, current, or fit for any particular purpose.",
  },
  {
    h: "3. AI-Generated Content Disclaimer",
    p: "Diagnostic reports and recommendations on SCMBrain are generated in part using artificial intelligence (large language models). AI-generated content may contain inaccuracies, omissions, outdated information, or errors. Recommendations should be independently reviewed and validated before any decision is made. AI outputs must not be relied upon as professional advice, and SCMBrain is not responsible for actions taken based on them.",
  },
  {
    h: "4. Assessment Limitation Disclaimer",
    p: "Maturity scores, ratings, benchmarks, and recommendations produced by the Intelligent SCM Scan are indicative and directional only. They are based entirely on self-reported inputs and general industry frameworks. They do not constitute certifications, audits, compliance determinations, guarantees, or definitive measures of organizational capability, and should not be represented as such.",
  },
  {
    h: "5. No Guarantee of Outcomes",
    p: "SCMBrain does not guarantee any specific result, performance improvement, cost saving, or business outcome from use of its assessments, tools, or content. Results depend on factors outside SCMBrain's control, including the accuracy of your inputs and the quality of your implementation.",
  },
  {
    h: "6. Limitation of Liability",
    p: "To the maximum extent permitted by law, SCMBrain and its owners, contributors, and affiliates accept no liability for any loss or damage arising from reliance on assessment results, AI-generated outputs, or any content on this platform. Your use of the Services is entirely at your own risk.",
  },
  {
    h: "7. Governing Law",
    p: "This Disclaimer is governed by the laws of India, and any disputes are subject to the exclusive jurisdiction of the courts located in India, consistent with our Terms of Use.",
  },
];

export default function Disclaimer() {
  return (
    <Layout>
      <Seo
        title="Disclaimer | SCMBrain"
        description="Important disclaimers covering SCMBrain's AI-generated reports, assessment scores, and the informational-only nature of all outputs."
        path="/disclaimer"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">Legal</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B]">Disclaimer</h1>
        <p className="mt-4 text-[#94A3B8] text-sm">Last updated: February 2026</p>

        <div className="mt-10 space-y-9">
          {SECTIONS.map((c) => (
            <div key={c.h}>
              <h2 className="font-heading text-lg font-bold text-[#1B3A6B] mb-2">{c.h}</h2>
              <p className="text-[#3E577A] leading-relaxed text-[15px]">{c.p}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
